export default __webpack_public_path__ + "static/loja-1-897eb7af9007a69a65f34a81efd9c1c9.png";